import { render } from "./TraderForm.vue?vue&type=template&id=6101e285"
import script from "./TraderForm.vue?vue&type=script&lang=js"
export * from "./TraderForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__